import { styled } from '@mui/material/styles';

export const SummaryContainer = styled('div')<{
  hasDiscount?: boolean;
  maxWidth?: string;
}>(({ maxWidth, hasDiscount }) => {
  return {
    width: '100%',
    backgroundColor: 'white',
    padding: hasDiscount ? '16px' : '17.5px 16px',
    display: 'flex',
    gap: 12,
    flexDirection: 'column',
    height: hasDiscount ? 84 : 56,
    maxHeight: hasDiscount ? 84 : 56,
    minHeight: hasDiscount ? 84 : 56,
    maxWidth,
  };
});

export const Title = styled('p')({
  fontSize: 14,
  fontWeight: 600,
  lineHeight: '21px',
  letterSpacing: '0.15px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  margin: 0,
});

export const TotalPriceValue = styled('p')({
  fontSize: 14,
  fontWeight: 500,
  lineHeight: '21px',
  letterSpacing: '0.15px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  margin: 0,
});

export const ContinueButton = styled('button')(({ theme }) => ({
  width: '100%',
  height: 42,
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  borderRadius: 24,
  border: 'none',
  cursor: 'pointer',
}));

export const CartContainer = styled('div')<{ isDesktop: boolean }>(
  ({ isDesktop, theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    minHeight: 'calc(100vh - 64px)',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    padding: isDesktop ? '40px 0' : '0',
    backgroundColor: theme.palette.grey[100],
    [theme.breakpoints.up('md')]: {
      gap: 16,
    },
  }),
);

export const NavBarTitle = styled('p')(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.text.primary,
  position: 'absolute',
  left: '50%',
  transform: 'translate(-50%, 0%)',
  fontWeight: 600,
  lineHeight: '21px',
  letterSpacing: '0.15px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  margin: '0 auto',
}));

export const ContainerMainTitle = styled('p')(({ theme }) => ({
  fontSize: 20,
  color: theme.palette.text.primary,
  fontWeight: 600,
  lineHeight: '24px',
  alignSelf: 'flex-start',
  height: 36,
  justifyContent: 'space-between',
  letterSpacing: '0.15px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  margin: '0',
}));

export const ProductsDetailsContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
});

export const TotalSavedText = styled('p')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  color: theme.palette.success.dark,
  margin: 0,
  textAlign: 'left',
  '& strong': {
    fontWeight: 600,
  },
}));
